export const getBrandingLogo = (logo) => {
  if (typeof logo !== "string") {
    return URL.createObjectURL(logo);
  } else {
    return logo;
  }
};
